import request from '@/utils/request/index';

export interface InitAvatarRequest {
  /** 分身描述，选填，最长 200 个字符 */
  description?: string;
  /** 分身名称，必填，最长 24 个字符 */
  name?: string;
  [property: string]: any;
}

export interface InitAvatarResult {
  /** 分身 ID，后续所有步骤的操作标识 */
  botId?: string;
  [property: string]: any;
}

export interface QueryAvatarCoverStatusRequest {
  /** 分身 ID */
  botId?: string;
  /** 可选：来源图 URL，用于查询指定生成批次 */
  sourceUrl?: string;
  [property: string]: any;
}

export interface AvatarCoverResult {
  /** 封面图片 OSS URL，generateStatus=1 时有值，其余为 null */
  coverUrl?: string;
  /** 生成状态：0-生成中，1-成功，2-失败 */
  generateStatus?: number;
  /** 封面主键 ID，选择封面时作为 coverId 传入 */
  id?: number;
  /** 是否被选中：0-未选中，1-已选中 */
  isSelected?: number;
  /** 展示排序，数值越小越靠前 */
  sort?: number;
  /** 风格编码，见 AvatarStyleEnum.styleCode */
  styleCode?: string;
  /** 风格名称，直接展示给用户 */
  styleName?: string;
  [property: string]: any;
}

export interface AvatarCoverStatusResponse {
  code?: number;
  data?: AvatarCoverResult[];
  message?: string;
  [property: string]: any;
}

export interface EditAvatarRequest {
  /** 可见范围编码，选填 */
  avatarScope?: number;
  /** 分身 ID，必填 */
  botId?: string;
  /** 封面主键 ID，选择生成封面时传入 */
  coverId?: number;
  /** 用户上传的封面图 URL，传入后会作为默认封面并同步到 avatar */
  coverUrl?: string;
  /** 分身描述，选填，最长 200 个字符 */
  description?: string;
  /** 分身名称，选填，最长 24 个字符 */
  name?: string;
  /** 绑定视频 ID，选填，更新时会校验视频归属权 */
  videoId?: number;
  [property: string]: any;
}

export interface AvatarListRequest {
  isLimit?: boolean;
  lastId?: number;
  page?: number;
  size?: number;
  [property: string]: any;
}

export interface PaginatedResultDataAvatarListItemResult {
  currentPage?: number;
  list?: AvatarListItemResult[];
  totalCount?: number;
  totalPage?: number;
  [property: string]: any;
}

export interface AvatarListItemResult {
  avatar?: string;
  avatarScope?: number;
  botId?: string;
  description?: string;
  name?: string;
  [property: string]: any;
}

export const feimaChatBotAvatarInit = (
  data: InitAvatarRequest,
  options?: any
): Promise<InitAvatarResult> =>
  request<any>('/bot/avatar/init', 'POST', data, options);

export const feimaChatBotAvatarQueryCoverStatus = (
  data: QueryAvatarCoverStatusRequest,
  options?: any
): Promise<AvatarCoverResult[] | AvatarCoverStatusResponse> =>
  request<any>(
    '/bot/avatar/queryCoverStatus',
    'POST',
    data,
    options ?? { noMessage: false }
  );

export const feimaChatBotAvatarEdit = (
  data: EditAvatarRequest,
  options?: any
): Promise<null> => request<any>('/bot/avatar/edit', 'POST', data, options);

export const feimaChatBotCheckDefaultAgent = (
  data: AvatarListRequest = {},
  options?: any
): Promise<PaginatedResultDataAvatarListItemResult> =>
  request<any>('/bot/avatar/list', 'POST', data, options);

export const feimaChatUserVideoDelete = (
  data: { userVideoId?: number },
  options?: any
): Promise<null> =>
  request<any>('/userAiMaterial/video/del', 'POST', data, options);

export interface VideoUploadWithVoiceTrainRequest {
  botId?: string;
  title?: string;
  userId?: string;
  videoUrl?: string;
  [property: string]: any;
}

export const feimaChatBotVideoUploadWithVoiceTrain = (
  data: VideoUploadWithVoiceTrainRequest,
  options?: any
): Promise<null> =>
  request<any>(
    '/userAiMaterial/v2/video/uploadWithVoiceTrain',
    'POST',
    data,
    options ?? { noMessage: false }
  );

export interface GenerateAvatarCoversRequest {
  aiGenerateEnabled?: boolean;
  botId?: string;
  sourceUrl?: string;
  [property: string]: any;
}

export const feimaChatBotAvatarGenerateCovers = (
  data: GenerateAvatarCoversRequest,
  options?: any
): Promise<AvatarCoverResult[]> =>
  request<any>('/bot/avatar/generateCovers', 'POST', data, options);

/**
 * 设置分身出镜范围
 * avatarScope: 1-所有人, 4-仅粉丝, 5-仅自己
 */
export const feimaChatBotAvatarSetScope = (
  data: { avatarScope?: number; botId?: string },
  options?: any
): Promise<null> => request<any>('/bot/avatar/setScope', 'POST', data, options);
